import {observer} from "mobx-react";
import {useContext} from "react";
import {Button, Typography} from "@mui/material";
import {useTheme} from "@mui/material/styles";
import AddIcon from "@mui/icons-material/Add";
import {Frame} from "../../common/Frame";
import {LessonEditorStoreContext} from "../../../stores/LessonEditorStore";
import {ChapterEditor} from "./ChapterEditor";
import {AnnotationSelectorDialog} from "./AnnotationSelectorDialog";

const AddChapterButton = observer(({atOrder}: { atOrder: number }) => {
  const store = useContext(LessonEditorStoreContext);
  const theme = useTheme();

  const handleAddChapter = async () => {
    const chapterNumber = (store?.lesson?.chapters?.length ?? 0) + 1;
    await store?.createChapter(`Chapter ${chapterNumber}`, atOrder);
  };

  return (
    <Frame center paddingV={0.5}>
      <Button
        variant="text"
        size="small"
        startIcon={<AddIcon style={{fontSize: 16}}/>}
        onClick={handleAddChapter}
        disabled={store?.saving}
        sx={{
          color: theme.palette.primary.main,
          fontSize: 12,
          textTransform: 'none',
        }}
      >
        Add chapter
      </Button>
    </Frame>
  );
});

export const LessonEditorContent = observer(() => {
  const store = useContext(LessonEditorStoreContext);

  if (!store || !store.lesson) return null;

  const chapters = store.lesson.chapters ?? [];

  return (
    <Frame direction="column">
      <Typography variant="h6" fontWeight={600}>
        Chapters
      </Typography>

      <AddChapterButton atOrder={0}/>

      {chapters.map((chapter, index) => (
        <Frame key={chapter.id} direction="column">
          <ChapterEditor chapter={chapter}/>
          <AddChapterButton atOrder={(chapter.order ?? index) + 1}/>
        </Frame>
      ))}

      <AnnotationSelectorDialog/>
    </Frame>
  );
});
